<template>
  <v-container grid-list-xs>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <h1 class="display-1">I Am...</h1>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5">
      <v-flex xs12 sm8 offset-sm2>
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card color="primary" class="white--text eq-height" height="100%">
                <v-card-title primary-title>
                  <div class="headline">A New Customer</div>
                  <div>I've never done business with {{ brand.displayName }} before.</div>
                </v-card-title>
                <v-card-actions>
                  <v-btn color="accent" dark to="new-activation" :block="$vuetify.breakpoint.xsOnly">Sign Up</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>   
            <v-flex xs12 md6>
              <v-card color="primary" class="white--text eq-height" height="100%">
                <v-card-title primary-title>
                  <div class="headline">An Existing Customer</div>
                  <div>I have an account with {{ brand.displayName }}</div>
                </v-card-title>
                <v-card-actions>                  
                  <v-btn color="accent" dark to="login" :block="$vuetify.breakpoint.xsOnly">Sign In</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>  
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>    
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/activation/AccountType.vue